import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { setChatStatus } from "service/chat";
import { useTranslation } from "react-i18next";
import getChatManualFlag from "service/chat/GetChatManualFlag";

import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";
import MultipleOptionsButton from "components/General/MultipleOptionsButton";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";
import GeneralActionButtonsModal from "components/General/GeneralActionButtonsModal";

export default function AgentChatStausCard() {
  const { t } = useTranslation();
  const { csrUser } = useSelector((s) => s.csrUser);

  const [isLoading, setIsLoading] = useState(false);
  const [currentChatStatus, setCurrentChatStatus] = useState("");
  const [selectedChatStatus, setSelectedChatStatus] = useState("");

  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [confirmationDialogState, setConfirmationDialogState] = useState(false);
  const [confirmationMessageDialogState, setConfirmationMessageDialogState] =
    useState(false);

  const toggleLiveChat = async () => {
    setIsLoading(true);
    await setChatStatus({
      userId: csrUser?.userId,
      flag: selectedChatStatus,
      portal: "agent",
    }).then((res) => {
      setIsLoading(false);
      setConfirmationDialogState(false);
      if (res.ok) {
        setCurrentChatStatus(selectedChatStatus);
        setConfirmationMessageDialogState(true);
        setConfirmationMessage(
          `Chat status has been changed to ${
            selectedChatStatus === "0"
              ? "offline"
              : selectedChatStatus === "1"
              ? "online"
              : "auto"
          } successfully.`
        );
      } else {
        setConfirmationMessageDialogState(true);
        setConfirmationMessage(
          `Chat status was not changed to ${
            selectedChatStatus === "0"
              ? "offline"
              : selectedChatStatus === "1"
              ? "online"
              : "auto"
          } please try again later.`
        );
        console.error(res);
      }
    });
  };

  // run to get current chat status
  useEffect(() => {
    const configChatStatus = async () => {
      try {
        setIsLoading(true);
        const agentChatStatusResponse = await getChatManualFlag("agent");
        setCurrentChatStatus(agentChatStatusResponse);
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    };

    configChatStatus();
  }, []);

  return (
    <EverlakeLoadingOverlay isLoading={isLoading} spinnerSize="sm">
      <MultipleOptionsButton
        selected={currentChatStatus}
        buttonLabel={t("AgentCSR-Admin-AgentChatStausCard-btn-label")}
        options={[
          {
            value: "1", // on
            label: t("CSRAdminChatStatus-label-1"),
            disclaimer: t("CSRAdminChatStatus-disclaimer-1"),
            action: () => {
              setSelectedChatStatus("1");
              setConfirmationDialogState(true);
            },
          },
          {
            value: "2", // auto
            label: t("CSRAdminChatStatus-label-2"),
            disclaimer: t("CSRAdminChatStatus-disclaimer-2"),
            action: () => {
              setSelectedChatStatus("2");
              setConfirmationDialogState(true);
            },
          },
          {
            value: "0", // off
            label: t("CSRAdminChatStatus-label-3"),
            disclaimer: t("CSRAdminChatStatus-disclaimer-3"),
            action: () => {
              setSelectedChatStatus("0");
              setConfirmationDialogState(true);
            },
          },
        ]}
        portalType="agent"
      />

      <GeneralActionButtonsModal
        title={t("CSRAdminChatStatus-confirmation-title-1", {
          portalType: t("CSRAdminChatStatus-portalAgent"),
        })}
        description={`Are you sure you want to turn chat ${
          selectedChatStatus === "0"
            ? "off"
            : selectedChatStatus === "1"
            ? "on"
            : "auto"
        }?`}
        primaryButtonText={t("CSRAdminChatStatus-button-yes")}
        secondaryButtonText={t("CSRAdminChatStatus-button-no")}
        dialogState={confirmationDialogState}
        setDialogState={setConfirmationDialogState}
        primaryButtonAction={async () => await toggleLiveChat()}
        primaryButtonDisabled={isLoading}
        secondaryButtonAction={() => setConfirmationDialogState(false)}
      />

      <GeneralPurposeDialog
        state={confirmationMessageDialogState}
        setState={setConfirmationMessageDialogState}
        title={t("CSRAdminChatStatus-confirmation-title-2", {
          portalType: t("CSRAdminChatStatus-portalAgent"),
        })}
        desc={confirmationMessage}
      />
    </EverlakeLoadingOverlay>
  );
}
